import { createFileRoute } from '@tanstack/react-router';
import { RfqDetailPage } from '../../features/rfq';

export const Route = createFileRoute('/portal/rfq/$id')({ component: RfqDetailPage });
